module.exports = __webpack_public_path__ + "3f90d32e3139c40693c7897d4251d6ea.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-extralight.ttf
// module id = 29
// module chunks = 0 1 2 3 4 5 6 7 8 9